import { render, staticRenderFns } from "./TabReconceptualizacion.vue?vue&type=template&id=0f8a275f&scoped=true&"
import script from "./TabReconceptualizacion.vue?vue&type=script&lang=js&"
export * from "./TabReconceptualizacion.vue?vue&type=script&lang=js&"
import style0 from "./TabReconceptualizacion.vue?vue&type=style&index=0&id=0f8a275f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a275f",
  null
  
)

export default component.exports